import { api } from '@/service/http';

export const sendSupportRequest = async requestBody => {
    try {
        const { success, data } = await api('notify./send', requestBody);
        console.log(data);
        return success ? data : {};
    } catch (error) {
        return {
            result: false,
            message: error.message,
            uuid: 'b7f95268-4451-4af3-9da4-c0486ef8fa36',
        };
    }
};
